"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const widgetsNames_1 = require("./widgetsNames");
const helper_1 = require("../../common/helper");
const Conditional_1 = require("evolution-frontend/lib/actions/utils/Conditional");
const widgets_1 = require("./widgets");
exports.currentSectionName = 'travelBehavior';
const previousSectionName = 'segments';
const nextSectionName = 'personsTrips';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Mobilité',
        en: 'Travel behavior'
    },
    widgets: widgetsNames_1.widgetsNames,
    enableConditional: function (interview) {
        const person = odSurveyHelper.getPerson({ interview });
        const journey = person !== null ? odSurveyHelper.getJourneysArray({ person })[0] : null;
        if (journey === null) {
            return false;
        }
        return (0, helper_1.householdMembersSectionComplete)(interview) && (0, helper_1.tripsForPersonComplete)({ person, interview });
    },
    isSectionCompleted: function (interview) {
        const person = odSurveyHelper.getPerson({ interview });
        return ((0, helper_1.householdMembersSectionComplete)(interview) && (0, helper_1.tripDiaryAndTravelBehaviorForPersonComplete)(person, interview));
    },
    isSectionVisible: function (interview, iterationContext) {
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        const journey = odSurveyHelper.getJourneysArray({ person })[0];
        // Check the conditional of the personNoWorkTripReason, personNoSchoolTripReason and personWhoAnsweredForThisPerson widgets
        const [personNoWorkTripConditional] = (0, Conditional_1.checkConditional)(widgets_1.personNoWorkTripReason.conditional, interview, `household.persons.${person._uuid}.journeys.${journey._uuid}.noWorkTripReason`);
        const [personNoSchoolTripConditional] = (0, Conditional_1.checkConditional)(widgets_1.personNoSchoolTripReason.conditional, interview, `household.persons.${person._uuid}.journeys.${journey._uuid}.noSchoolTripReason`);
        return person && (personNoWorkTripConditional === true || personNoSchoolTripConditional === true);
    }
};
exports.default = exports.sectionConfig;
